import { render } from "./LiveStats.vue?vue&type=template&id=622ff79e"
import script from "./LiveStats.vue?vue&type=script&lang=js"
export * from "./LiveStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LiveStats.vue?vue&type=style&index=0&id=622ff79e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__